/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import {  Individu, ListeRecensement } from '@/types';
import { validationAdresse, validationInformationsContact } from '..';

const validationStep2 = (
  individu: Partial<Individu>,
) => (_.pickBy({
    ...(individu?.recensement !== ListeRecensement.NonRecenses && {
      adresseRattachement: validationAdresse(individu?.adresseRattachement, null)?.adresse,
    }),
    ...validationInformationsContact(individu),
  }, v => !_.isNil(v) && !_.isEmpty(v))
);


export default validationStep2;
